"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.H6 = exports.H5 = exports.H4 = exports.H3 = exports.H2 = exports.H1 = void 0;
var create_rocket_1 = require("../_util/create-rocket");
exports.H1 = create_rocket_1.createRocket("H1", "h1.@{prefix}-h1");
exports.H2 = create_rocket_1.createRocket("H2", "h2.@{prefix}-h2");
exports.H3 = create_rocket_1.createRocket("H3", "h3.@{prefix}-h3");
exports.H4 = create_rocket_1.createRocket("H4", "h4.@{prefix}-h4");
exports.H5 = create_rocket_1.createRocket("H5", "h5.@{prefix}-h5");
exports.H6 = create_rocket_1.createRocket("H6", "h6.@{prefix}-h6");
//# sourceMappingURL=Heading.js.map